var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-aa9fecac\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CartNavbarSVG.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/CartNavbarSVG.vue
// module id = 589
// module chunks = 66